import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import instagram from '../../images/icons/instagram.svg';
import linkedin from '../../images/icons/linkedin.svg';
import logo from '../../images/logo.svg';
import './Footer.css';
import { useLanguage } from '../../context/LanguageContext'; // Fix import path

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { title: t('footer.nav.home'), section: null, path: '/' },
    { title: t('footer.nav.services'), section: 'services-section', path: '/' },
    { title: '¿Cómo trabajamos?', section: 'how-we-work-section', path: '/' },
    { title: t('footer.nav.clients'), section: 'clientes-section', path: '/' },
    { title: '¿Es para tu negocio?', section: 'categories-section', path: '/' },
    { title: t('footer.nav.contact'), section: 'contact-section', path: '/' },
  ];

  // Scroll to section by id, navigating home if needed (same as Banner.tsx)
  const handleFooterLinkClick = (e: React.MouseEvent, section: string | null, path: string) => {
    if (section === null && path === '/') {
      // INICIO: scroll to top
      e.preventDefault();
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    if (section) {
      e.preventDefault();
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // else, let Link handle navigation
  };

  return (
    <footer className="footer">
      <Container>
        <Row className="justify-content-between align-items-start">
          <Col md={4}>
            <div className="footer-brand">
              <img src={logo} alt="Lucods" className="footer-logo" />
              <p className="text-font address">{t('footer.address')}</p>
              <p className="text-font address" style={{ marginBottom: '0.5rem', opacity: 0.9 }}>
                {t('footer.email')}<br />
                {t('footer.phone')}
              </p>
              <p className="text-font copyright">{t('footer.rights')}</p>
            </div>
          </Col>
          <Col md={6}>
            <div className="footer-links">
              <div className="links-grid">
                {links.map((link) => (
                  <a
                    key={link.title}
                    href={link.section ? `#${link.section}` : '/'}
                    className="footer-link"
                    onClick={e => handleFooterLinkClick(e, link.section, link.path)}
                  >
                    {link.title}
                  </a>
                ))}
              </div>
              <div className="social-links">
                <a href="https://www.instagram.com/lucods_tech/?hl=es" target="_blank" rel="noopener noreferrer">
                  <img src={instagram} alt="Instagram" className="social-icon" />
                </a>
                <a href="https://ar.linkedin.com/company/lucods" target="_blank" rel="noopener noreferrer">
                  <img src={linkedin} alt="LinkedIn" className="social-icon" />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;